export default {
    setUser(state, userData) {
        state.user = userData;
    },
    setToken(state, token) {
        state.token = token;
    },
    setInPage(state, inPage) {
        state.inPage = inPage;
    },
    setIsLoggedIn(state, isLoggedIn) {
        state.isLoggedIn = isLoggedIn;
    },
    setStartDate(state, startDate) {
        state.startDate = startDate;
    },
    setIsFetchedStartDate(state, isFetchedStartDate) {
        state.isFetchedStartDate = isFetchedStartDate;
    },
    setHistory(state, history) {
        state.history = history;
    },
};
